import React from 'react';
import { useLang } from './store';

export const LangText = ({ id, replace }) => {
    const { country, lang } = useLang();

    let v = lang?.[id]?.[country];
    if (replace) {
        v = v?.replace(replace?.key, replace?.val);
    }

    if (v) {
        return String(v).replace("\\n", "\n");
    } else {
        return id
    }
};


export const ContentTypeText = ({ value }) => {
    const { country } = useLang();

    let result = value

    if (country == "en") {
        if (value == "기본") { result = "Default" }
        if (value == "아트") { result = "Art" }
        if (value == "영화") { result = "Cinematic" }
        if (value == "카툰") { result = "Cartoon" }
        if (value == "얼굴사진") { result = "Portrait" }
    }

    return result;
};

export const QualityText = ({ value }) => {
    const { country } = useLang();

    let result = value

    if (country == "en") {
        if (value == "원본 유지") { result = "Original" }
        if (value == "실사") { result = "Live" }
        if (value == "애니메이션") { result = "Animation" }
        if (value == "디노이징 적용") { result = "Denoising" }
    } else if (country == "ko") {
        if (value == "원본 유지") { result = "원본유지" }
        if (value == "실사") { result = "실사" }
        if (value == "애니메이션") { result = "애니메이션" }
        if (value == "디노이징 적용") { result = "디노이" }
    }

    return result;
};

export const OptionHeader = ({
    type = "ps",
    value
}) => {
    const { country } = useLang();
    let result = value

    if (type == "nt") {
        if (country == "ko") {
            result = "부정 프롬프트"
        } else if (country == "en") {
            result = "Negative Prompt"
        }
    } else if (type == "ctt") {
        if (country == "ko") {
            result = "유형"
        } else if (country == "en") {
            result = "Type"
        }
    } else if (type == "ps") {
        if (country == "ko") {
            result = "프롬프트 강도"
        } else if (country == "en") {
            result = "Prompt Strength"
        }
    } else if (type == "st") {
        if (country == "ko") {
            result = "스타일"
        } else if (country == "en") {
            result = "Style"
        }
    } else if (type == "stf") {
        if (country == "ko") {
            result = "이미지업로드"
        } else if (country == "en") {
            result = "Upload Image"
        }
    } else if (type == "ss") {
        if (country == "ko") {
            result = "스타일 강도"
        } else if (country == "en") {
            result = "Style Strength"
        }
    } else if (type == "phs") {
        if (country == "ko") {
            result = "원본 강도"
        } else if (country == "en") {
            result = "Reference Strength"
        }
    } else if (type == "vs") {
        if (country == "ko") {
            result = "영상 반영값"
        } else if (country == "en") {
            result = "Reference Strength"
        }
    } else if (type == "resol") {
        if (country == "ko") {
            result = "해상도"
        } else if (country == "en") {
            result = "Resolution"
        }
    } else if (type == "sample") {
        if (country == "ko") {
            result = "샘플러"
        } else if (country == "en") {
            result = "Sampler"
        }
    } else if (type == "seed") {
        if (country == "ko") {
            result = "시드"
        } else if (country == "en") {
            result = "Seed"
        }
    } else if (type == "step") {
        if (country == "ko") {
            result = "스텝"
        } else if (country == "en") {
            result = "Step"
        }
    } else if (type == "public") {
        if (country == "ko") {
            result = "공개"
        } else if (country == "en") {
            result = "Share"
        }
    } else if (type == "private") {
        if (country == "ko") {
            result = "비공개"
        } else if (country == "en") {
            result = "Private"
        }
    } else if (type == "x") {
        if (country == "ko") {
            result = "배"
        } else if (country == "en") {
            result = "x"
        }
    } else if (type == "ea") {
        if (country == "ko") {
            result = "확장 영역"
        } else if (country == "en") {
            result = "Expansion Area"
        }
    } else if (type == "qo") {
        if (country == "ko") {
            result = "보정 옵션"
        } else if (country == "en") {
            result = "Quality Option"
        }
    } else if (type == "tvv") {
        // 세로
        if (country == "ko") {
            result = "세로"
        } else if (country == "en") {
            result = "Vertical"
        }
    } else if (type == "tvh") {
        // 가로
        if (country == "ko") {
            result = "가로"
        } else if (country == "en") {
            result = "Horizontal"
        }
    } else if (type == "tvr") {
        // 정사각
        if (country == "ko") {
            result = "정사각"
        } else if (country == "en") {
            result = "Square"
        }
    }

    return result
}
